import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { getOngoingRequests } from "../../../actions/requests";

import RequestInfo from "../RequestInfo/RequestInfo";

import "./OngoingRequests.css";
import { KeyboardArrowDown } from "@material-ui/icons";

const OngoingRequests = () => {
  dayjs.extend(relativeTime);
  const dispatch = useDispatch();
  const requests = useSelector((state) => state.requests.ongoing);
  const [loading, setLoading] = useState(true);
  const [request, setRequest] = useState({});
  const [skip, setSkip] = useState(0);
  const [showInfo, setShowInfo] = useState(false);

  const getRequests = useCallback(() => {
    dispatch(
      getOngoingRequests({ status: { status: "ongoing" }, skip: 0 }, setLoading)
    );
  }, [dispatch]);

  const handleNextPage = async () => {
    dispatch(
      getOngoingRequests(
        { status: { status: "ongoing" }, skip: skip + 20 },
        setLoading
      )
    );

    setSkip((skip) => skip + 20);
  };

  const handleAssign = (request) => {
    setRequest(request);
    setShowInfo(true);
  };

  useEffect(() => {
    if (requests.length === 0) getRequests();
    else setLoading(false);
  }, [getRequests, requests, showInfo]);

  useEffect(() => {
    if (showInfo) {
      document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("BODY")[0].style.overflow = "auto";
    }
  }, [showInfo]);

  console.log(requests);

  return (
    <>
      {showInfo && (
        <RequestInfo
          setShowInfo={setShowInfo}
          request={request}
          requestsLength={requests.length}
          ongoingRequest
        />
      )}
      <div className="pending">
        <h2 className="mb-40 py-20 font-subhead">
          ONGOING REQUESTS
          <span
            style={{ background: "rgb(255, 236, 200)", color: "orange" }}
            className="admin__project__counter text-center font-bigger px-40 ml-20 curved-20"
          >
            {requests.length}
          </span>
        </h2>
        <div className="admin__scroll__ctn">
          <div className="admin__scroll__1024 d-flex w-100 mb-40">
            <span className="admin__serial font-bold">S/N</span>
            <div className="grid c-6 w-90 px-10">
              <span className="font-bold">Project Name</span>
              <span className="font-bold">Service</span>
              <span className="font-bold">Email</span>
              <span className="font-bold">Delivery Date</span>
              <span className="font-bold">Category</span>
            </div>
          </div>
          {loading ? (
            <div className="loader mx-auto">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          ) : (
            <>
              {requests.length < 1 && (
                <div className="font-bolder font-bigger text-center">
                  No ongoing requests
                </div>
              )}
              {requests.map((request, index) => (
                <div
                  className="admin__projects admin__scroll__1024 d-flex align-center pointer"
                  key={index}
                >
                  <span className="admin__serial font-bold">{index + 1}</span>
                  <div className="grid align-center c-6 w-90 p-10 my-10 rounded box-shadow-lg">
                    <span title={request.name} className="ellipsis pr-10">
                      {request.name}
                    </span>
                    <span
                      title={request.service}
                      className="text-uppercase ellipsis pr-10"
                    >
                      {request.service}
                    </span>
                    <span title={request.email} className="ellipsis pr-10">
                      {request.email}
                    </span>
                    <span
                      title={dayjs(request.createdAt).format(
                        "dddd, MMMM D YYYY"
                      )}
                    >
                      {dayjs(request.createdAt).fromNow()}
                    </span>
                    <span title={request.category} className="text-capitalise">
                      {request.category}
                    </span>
                    <div className="d-flex justify-center">
                      <button
                        className="border-0 outline-0 w-75 font-bold rounded"
                        onClick={() => handleAssign(request)}
                      >
                        Details
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
          {!loading && requests > 19 && (
            <div
              className="d-flex justify-center p-20 pointer"
              onClick={handleNextPage}
            >
              <div className="d-flex align-center border-1 px-20 py-5 curved-20">
                <span className="font-bold">View More</span>
                <KeyboardArrowDown className="ml-5" fontSize="large" />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OngoingRequests;
